import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StypeProps = {
  smallMedia: boolean
  scrollbar: boolean
  hideMobileFooter: boolean
  centerContent: boolean
  disablePadding: boolean
  pageWidth?: number
  isKeyboardOpen: boolean
}

const useStyles = makeStyles<Theme, StypeProps>(theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    width: '100vw',
    minHeight: ({ smallMedia }) => (smallMedia ? '0' : '600px'),
    height: '100svh',
    maxHeight: ({ smallMedia, hideMobileFooter, isKeyboardOpen }) =>
      smallMedia && !hideMobileFooter && !isKeyboardOpen
        ? 'calc(100svh - 64.5px)'
        : 'unset',
    overflowY: ({ scrollbar }) => (scrollbar ? 'auto' : 'hidden'),
    position: 'fixed',

    '& .MuiAvatar-img': {
      background: 'rgba(173, 194, 204, 0.9)'
    },

    [theme.breakpoints.down('lg')]: {
      overflowX: 'auto',
      overflowY: 'auto'
    }
  },

  contentArea: {
    flex: '1 1 auto',
    // here, 110 px is for the margin of the side nav, and some few extra pixels just to make it look more spaced.
    maxWidth: ({ pageWidth }) =>
      pageWidth ? `calc(100vw - (${pageWidth}px + 116px))` : 'initial',
    margin: '0 0 0 120px',

    // Full width on mobile
    [theme.breakpoints.down('md')]: {
      margin: '0',
      width: '100%',
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },

  mainContent: {
    display: 'flex',
    justifyContent: ({ centerContent }) => (centerContent ? 'center' : 'unset'),
    width: ({ disablePadding }) =>
      disablePadding ? '100%' : 'calc(100% - 1rem)',
    padding: ({ disablePadding }) => (disablePadding ? 0 : '0.5rem'),
    minHeight: 'calc(100vh - 96px)',
    position: 'relative',
    backgroundColor: '#F0F0F0',

    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      padding: '0 !important',
      minHeight: '100%'
    }
  }
}))

export default useStyles
